import React, { useRef, useState, useEffect, forwardRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { API_URL_All } from '../../api';
import axios from "axios";
import { toast } from "react-toastify";
import * as general from '../../libs/general';
import axiosInstance from '../../axiosInstance';

const Fee4Editor = ({ data, handleSearch }) => {
  const [show, setShow] = useState(true);
  const [isLocked, setIsLocked] = useState(true);
  const [model, setModel] = useState({});

  useEffect(() => {
    fetchOneRecord(data);
  }, [data]);

  const handleModalClose = (e) => {
    document.querySelectorAll('.show .error-msg').forEach((item) => {
      if (item.parentNode) {
        item.parentNode.removeChild(item);
      }
    });
    document.activeElement.blur();
    setShow(false);
  };

  const handleSubmitForm = async (e) => {
    e.preventDefault();
    var errorTag = e.currentTarget.querySelector('.error-msg');
    if (errorTag) return;

    try {
      var requestApi = `/api/contacts/saveContactFee`;
      if (model.levelId) requestApi = `/api/levels/saveFee`;
      const response = await axiosInstance.post(requestApi, model);
      if (!response.data.success) {
        general.showFormError('#form_fee_editor .modal-body', response.data);
        console.log(response.data);
        return;
      }
      console.log(response);
      toast.success(response.data.message);
      if (handleSearch) handleSearch();
      handleModalClose();
    } catch (error) {
      toast.error(error.response.data);
    }

  };

  const fetchOneRecord = async (params) => {
    document.querySelectorAll('form .error-msg').forEach((item) => { item.remove() });

    const isNumber = Number.isFinite(params.id);
    if (!isNumber) {
      params.id = 0;
    }
    try {
      var requestApi = `/api/contacts/getContactFee?id=${params.id}`;
      if (params.levelId) requestApi = `/api/levels/getFee?id=${params.id}`;
      const response = await axiosInstance.get(requestApi);

      var model = { ...response.data.data, no: params.no };
      if (!model.contactId) model.contactId = params.contactId;
      if (!model.levelId) model.levelId = params.levelId;
      if (!model.lineId) model.lineId = params.lineId;
      if (!model.type) model.type = params.type;
      if (!model.priceTypeId && params.priceTypeId) model.priceTypeId = params.priceTypeId;
      setModel(model);
      console.log(model);
      setIsLocked(response.data.data.locked);
      setShow(true);
    } catch (error) {
      console.error("Lỗi khi lấy dữ liệu:", error);
    }
  };

  return (
    <Modal show={show} onHide={handleModalClose} size="lg">
      <div className="">

        <form id="form_fee_editor" className="form_validate normal-form" autoComplete="off" onSubmit={handleSubmitForm}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{model.id && <span>Cập nhật</span>}{!model.id && <span>Thêm mục mới</span>}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleModalClose}
                aria-label="Đóng"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12 mb-3">
                  <div className="row">
                    <div className="col-md-1">
                      <label className="form-label d-none d-md-block">&nbsp;</label>
                      <div className="form-control item-no">
                        <b>#{model.no }</b>
                      </div>
                    </div>
                    <div className="col-6 col-md-2">
                      <label className="form-label" data-note={model.type}>Từ</label>
                      <div className="">
                        <input type="number" className="form-control" placeholder={model.type} disabled={model.locked} value={model.start ?? ''} onChange={(e) => setModel({ ...model, start: e.target.value })} />
                      </div>
                    </div>
                    <div className="col-6 col-md-2">
                      <label className="form-label" data-note={model.type}>Đến</label>
                      <div className="">
                        <input type="number" className="form-control" placeholder={model.type} disabled={model.locked} value={model.end ?? ''} onChange={(e) => setModel({ ...model, end: e.target.value })} />
                      </div>
                    </div>
                    <div className="col-6 col-md-2">
                      <label className="form-label" data-note="vnđ">Phí {model.type}</label>
                      <div className="">
                        <input type="number" className="form-control" placeholder="vnđ" disabled={model.locked} value={model.fee ?? ''} onChange={(e) => setModel({ ...model, fee: e.target.value })} />
                      </div>
                    </div>


                    <div className="mb-2 col-6 col-md-2 ">
                      <label className="form-label" data-note="vnđ">Phí đầu mục</label>
                      <div className="">
                        <input type="number" className="form-control" placeholder="vnđ" disabled={model.locked} value={model.feeItem ?? ''} onChange={(e) => setModel({ ...model, feeItem: e.target.value })} />
                      </div>
                    </div>
                    <div className="mb-2 col-6 col-md-3 ">
                      <label className="form-label" data-note="%">Phí ủy thác</label>
                      <div className="">
                        <input type="number" className="form-control" placeholder="vnđ" disabled={model.locked} value={model.feeEntrust ?? ''} onChange={(e) => setModel({ ...model, feeEntrust: e.target.value })} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
            <div className="modal-footer justify-content-between">
              <div>

              </div>
              <button type="submit" className="btn-sm btn btn-primary">Lưu phí</button>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default Fee4Editor;
